var _circle;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_101",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 101",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#d19f46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepPoint);
export default __webpack_public_path__ + "static/media/step_point.9f137f11780e9628917f08a15117d39d.svg";
export { ForwardRef as ReactComponent };